import React from "react";
import { Router, Activity } from "lucide-react";

interface DashboardTabsProps {
  activeTab: "routers" | "iqwatch-devices";
  setActiveTab: (tab: "routers" | "iqwatch-devices") => void;
  routersCount: number;
  iqwatchDevicesCount: number;
  // mpptsCount removed
  iqwatchDevicesLoading?: boolean;
  // 新增：各个部分是否有数据的标
  hasRouters?: boolean;
  // hasEdgeDevices removed - focusing on IQWatch devices only
  hasIQWatchDevices?: boolean;
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({
  activeTab,
  setActiveTab,
  routersCount,
  iqwatchDevicesCount,
  iqwatchDevicesLoading = false,
  hasRouters = true,
  // hasEdgeDevices removed - focusing on IQWatch devices only
  hasIQWatchDevices = true,
}) => (
  <div className="flex bg-gray-100 rounded-lg p-1">
    {/* MPPT Devices Tab removed - focusing on IQWatch devices only */}

    {/* Edge Devices Tab removed - focusing on IQWatch devices only */}

    {/* Routers Tab - 只在有数据时显示 */}
    {hasRouters && (
      <button
        onClick={() => setActiveTab("routers")}
        className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
          activeTab === "routers"
            ? "bg-white text-blue-600 shadow-sm"
            : "text-gray-600 hover:text-gray-800"
        }`}
      >
        <Router className="w-4 h-4" />
        <span>Routers ({routersCount})</span>
      </button>
    )}

    {/* iQWatch Devices Tab - 只在有数据时显示 */}
    {hasIQWatchDevices && (
      <button
        onClick={() => setActiveTab("iqwatch-devices")}
        className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
          activeTab === "iqwatch-devices"
            ? "bg-white text-blue-600 shadow-sm"
            : "text-gray-600 hover:text-gray-800"
        }`}
      >
        <Activity className="w-4 h-4" />
        <span>
          Devices
          {iqwatchDevicesLoading ? (
            <span className="ml-1">(Loading...)</span>
          ) : (
            <span>({iqwatchDevicesCount})</span>
          )}
        </span>
      </button>
    )}
  </div>
);

export default DashboardTabs;
